/* @flow */
/**
 * Internal dependencies
 */
import {
	A11Y_HIDE_FOCUS_STYLE,
	A11Y_SHOW_FOCUS_STYLE,
} from '../constants/action-types';

/**
 * Flow
 */
import type { Theme } from 'styled-components';

import type {
	A11yShowFocusStyleAction,
	A11yHideFocusStyleAction,
} from '../actions/a11y';

type ThemeReducerActions =
	A11yShowFocusStyleAction |
	A11yHideFocusStyleAction;

/**
 * Initial state
 */
const themes = {
	pink: {
		color: '#1a1a1a',
		hoverColor: '#1a1a1a',
		dark: '#1a1a1a',
		background: '#f7eded',
		backgroundDark: '#ffb4b4',
		backgroundLight: '#ffb4b4',
		backgroundMedium: '#ffb4b4',
		buttonChecked: '#ffb4b4',
		textOnbuttonChecked: '#1a1a1a',
	},
	purple: {
		background: '#ddd9fb',
		backgroundDark: '#1c0fd2',
		backgroundLight: '#f1efff',
		backgroundMedium: '#c8c1ff',
		buttonChecked: '#1c0fd2',
		textOnbuttonChecked: '#fff',
	},
	green: {
		background: '#d9fbdf',
		backgroundDark: '#38ef50',
		backgroundLight: '#d9fbdf',
		backgroundMedium: '#b1efbc',
		buttonChecked: '#38ef50',
		textOnbuttonChecked: '#4a4a4a',
	},
	blue: {
		hoverColor: '#fff',
		background: '#e6eef4',
		backgroundDark: '#0a5faa',
		backgroundLight: '#0a5faa',
		backgroundMedium: '#0a5faa',
		buttonChecked: '#0a5faa',
		textOnbuttonChecked: '#fff',
	},
};

let currentTheme = 'pink';

if ( window.brukHueConfig && window.brukHueConfig.theme ) {
	currentTheme = window.brukHueConfig.theme;
}

export const initialState = {
	a11y: false,
	color: '#4a4a4a',
	dark: '#4a4a4a',
	sliderBackground: '#f2f2f2',
	...themes[ currentTheme ],
};

/**
 * Reducer
 */
export default function theme( state: Theme = initialState, action: ThemeReducerActions ) : Theme {
	switch ( action.type ) {
		case A11Y_HIDE_FOCUS_STYLE:
		case A11Y_SHOW_FOCUS_STYLE:
			return {
				...state,
				a11y: action.payload,
			};

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/theme.js